import CmsUserPageBlock from './CmsUserPage';

export default CmsUserPageBlock;
